import React, { useState, useEffect } from 'react';
import { PatternFormat } from 'react-number-format';
import { FormikProps } from 'formik';

interface PropTypes {
  formikField: string;
  formik: FormikProps<any>;
  className?: string;
  placeholder?: string;
}

export const getPhoneFormat = (digits: string) => {
  if (digits?.startsWith('02')) {
    return { format: '##-####-####'};
  } else if (digits?.startsWith('0')) {
    return { format: '###-####-####'};
  } else {
    return { format: '####-####'};
  }
};

const PhoneInput: React.FC<PropTypes> = ({
  formikField,
  formik,
  className,
  placeholder,
}) => {
  const [format, setFormat] = useState('###-####-####');

  const handleValueChange = (values: { value: string; formattedValue: string }) => {
    const { value } = values;
    const digits = value.replace(/\D/g, '');

    if (digits.length >= 2) {
      const { format: newFormat } = getPhoneFormat(digits);
      setFormat(newFormat);
    }
    formik.setFieldValue(formikField, value);
  };

  useEffect(() => {
    const initialValue = formik.values[formikField] || '';
    const digits = initialValue.replace(/\D/g, '');
    if (digits) {
      const { format: newFormat } = getPhoneFormat(digits);
      setFormat(newFormat);
    }
  }, [formik.values[formikField]]);

  return (
    <PatternFormat
      className={className || 'form-control'}
      placeholder={placeholder || 'Enter phone number'}
      value={formik.values[formikField] || ''} 
      format={format} 
      onValueChange={handleValueChange}
    />
  );
};

export default PhoneInput;